import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import styles from './Profile.module.css';
import cn from 'classnames';

import { useTranslation } from 'react-i18next';

import User from '@icons/User.svg';
import UserWhite from '@icons/UserWhite.svg';
import Organization from '@icons/Organization.svg';
import OrganizationWhite from '@icons/OrganizationWhite.svg';

import { useForm } from '@mantine/form';
import Top from './Top';
import Form from './Form';
import OrganizationPage from './OrganizationPage';

import { Button } from '@mantine/core';

import useProfile from './hooks/useProfile';

import { organizationValidator, profileNameValidator } from '@utils/validators';

const Place = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [{ profile }, { fetch, update, updateOrg }] = useProfile(t);
  const navigate = useNavigate();

  let pageInitial = 'profile';

  for (const entry of searchParams.entries()) {
    const [param, value] = entry;

    if (param === 'page') {
      pageInitial = value
    }
  }

  const [page, setPage] = useState(pageInitial);

  const form = useForm({
    mode: 'uncontrolled',
    initialValues: {
      name: '',
      email: '',
      organizationName: ''
    },

    validate: {
      organizationName: (value) => organizationValidator(value, t),
      name: (value) => profileNameValidator(value, t)
    },
  });

  const fetchData = async () => {
    const data = await fetch();

    form.setValues(data)
  }

  useEffect(() => {
    fetchData();
  }, []);

  const handleSubmit = (values) => {

  }

  const handleSetPage = (value) => {
    setPage(value);

    navigate(`/profile?page=${value}`, { replace: true })
  }

  return (
    <div className={styles.wrapper}>
      <form
        onSubmit={form.onSubmit(handleSubmit)}
      >
        <Top page={page} form={form} update={update} updateOrg={updateOrg} />

        <div className={styles.content}>
          <div className={styles.menu}>
            <Button
              leftSection={<img src={page === 'profile' ? UserWhite : User} />}
              fullWidth
              justify='left'
              className={cn(styles.button, page === 'profile' && styles.active)}
              onClick={() => handleSetPage('profile')}
            >
              {t('profile')}
            </Button>

            <Button
              leftSection={<img src={page === 'organization' ? OrganizationWhite : Organization} />}
              fullWidth
              justify='left'
              className={cn(styles.button, page === 'organization' && styles.active)}
              onClick={() => handleSetPage('organization')}
            >
              {t('organization')}
            </Button>
          </div>

          <div className={styles.form}>
            {profile && page ==='profile' && <Form profile={profile} form={form} />}

            {profile && page ==='organization' && <OrganizationPage profile={profile} form={form} />}
          </div>
        </div>
      </form>
    </div >
  )
}

export default Place;
